import { productPrimaryImageStyles } from "@insite/content-library/Components/ProductPrimaryImage";
import { css } from "styled-components";

Object.assign(productPrimaryImageStyles, {
    centeringWrapper: {
        css: css`
            margin: 0;
            text-align: center;
        `,
    },
    img: {
        css: css`
            cursor: pointer;
            max-width: 100%;
        `,
    },
});
